// extracted by mini-css-extract-plugin
export default {"banner":"banner---bFSBG","icon":"icon---PZXCz","text":"text---cJWQy","heading":"heading---bz9Xe","body":"body---tJo_W","inline":"inline---LkNfr"};